import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { useAppSetting } from '../context/AppSettingContext';

function Dashboard({ user }) {
  const { appSetting } = useAppSetting();

  if (!user) {
    window.location.href = '/';
    return null;
  }

  return (
    <div className="tw min-h-screen w-full bg-slate-100">
      <div className="flex min-h-screen w-full">
        <div className="sticky top-0 h-screen shrink-0 overflow-y-auto bg-white shadow-sm z-10">
          <Sidebar role={user.role} user={user} />
        </div>

        <main className="min-w-0 flex-1 p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
